import { BaseEntity, TEntityCreating } from "@/backend/shared/repository/BaseEntity";

import { PermissionActions } from "../../permission/domain/Permission";

//

export interface ILimit extends BaseEntity {
  organizationId: string;
  limitType: ELimitType;
  currentValue: number;
  resetDate: Date | null;
}

//

export type ILimitCreating = TEntityCreating<ILimit>;

//

export enum ELimitType {
  products = "PRODUCTS",
  cabinets = "CABINETS",
  ordersPerMonth = "ORDERS_PER_MONTH",
  offerConnectsPerDay = "OFFER_CONNECTS_PER_DAY",
  offerConnectsPerMonth = "OFFER_CONNECTS_PER_MONTH",
}

//

export interface LimitItem {
  title: string;
  description?: string;
  blockOrganization?: boolean; // Заблокировать организацию при достижении лимита
  permissionActions: PermissionActions | PermissionActions[];
}

export const LIMITS: Record<ELimitType, LimitItem> = {
  PRODUCTS: {
    title: "Товаров",
    description: "Кол-во карточек, которые имеют связку с товаром.",
    permissionActions: ["products.create", "kaspiProducts.parse"],
  },
  CABINETS: {
    title: "Магазинов",
    permissionActions: "cabinets.connect",
  },
  ORDERS_PER_MONTH: {
    title: "Заказов в месяц",
    blockOrganization: true,
    permissionActions: "orders.create",
  },
  OFFER_CONNECTS_PER_DAY: {
    title: "Подключений карточек в день",
    description:
      "Кол-во карточек в день, которые можно подключить одной кнопкой через каталог Kaspi.",
    permissionActions: "kaspiProducts.connect",
  },
  OFFER_CONNECTS_PER_MONTH: {
    title: "Подключений карточек в месяц",
    description:
      "Кол-во карточек в месяц, которые можно подключить одной кнопкой через каталог Kaspi.",
    permissionActions: "kaspiProducts.connect",
  },
};
